import http from 'hub-http/clients/apiClient';
const CONDITIONAL_PROPERTIES_UNIFIED_RULES_URI = 'conditional-properties/v2/unified-rules?objectTypeId=0-3';
export function fetchForecastCategoryConditionalPropertyRules() {
  return http.get(CONDITIONAL_PROPERTIES_UNIFIED_RULES_URI);
}